import React from "react";
import PropTypes from "prop-types";


const PrintDocumentInfoHomeDepotFields = (props) => {
  const {styles, isContractSign, printState, messages} = props;

  const {View, Text} = window.ReactPdfRenderer;

  const {receiptHDLeadNumber, receiptBathroomLocation} = printState || {};

  return (
    <View>
      <Text style={styles.mainTitle}>{messages["grohe.cart.stepper.information"]}</Text>
      <View style={styles.homeDepotFieldRow}>
        <Text style={[styles.mainText, styles.homeDepotFieldLabel]}>HD Lead Number:</Text>
        <View style={styles.homeDepotFieldValue} receiptHDLeadNumberField={true}>
          <Text style={styles.mainText}>{!isContractSign ? receiptHDLeadNumber : ""}</Text>
        </View>
      </View>
      <View style={styles.homeDepotFieldRow}>
        <Text style={[styles.mainText, styles.homeDepotFieldLabel]}>Bathroom Location:</Text>
        <View style={styles.homeDepotFieldValue} receiptBathroomLocationField={true}>
          <Text style={styles.mainText}>{!isContractSign ? receiptBathroomLocation : ""}</Text>
        </View>
      </View>
      {/*<View style={styles.homeDepotFieldRow}>*/}
      {/*  <Text style={[styles.mainText, styles.homeDepotFieldLabel]}>Estimate Start:</Text>*/}
      {/*  <View style={styles.homeDepotFieldValue} receiptEstimateStartField={true}>*/}
      {/*    <Text style={styles.mainText}>{!isContractSign ? receiptEstimateStart : ""}</Text>*/}
      {/*  </View>*/}
      {/*</View>*/}
    </View>
  )
};

PrintDocumentInfoHomeDepotFields.propTypes = {
  fabricatorData: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  isContractSign: PropTypes.bool,
  printState: PropTypes.object,
};

export default PrintDocumentInfoHomeDepotFields
